import { createPinia } from 'pinia';
import { createApp } from 'vue';
import SiteSearchBar from '../../components/site-search-bar/site-search-bar.vue';
import SiteSearchBarResults from '../../components/site-search-bar/site-search-bar-results.vue';

const pinia = createPinia();

createApp(SiteSearchBar)
  .use(pinia)
  .mount('#pbc-site-search-bar');

createApp(SiteSearchBarResults)
  .use(pinia)
  .mount('#pbc-site-search-bar-results');
